export const getEncodedCheckMarkIconSvg = (color: string) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="${color}">
      <path d="M11.4336 1.3164c.3301.3047.3301.8379 0 1.1426l-6.5 6.5c-.3047.33-.8379.33-1.1426 0l-3.25-3.25c-.33-.3047-.33-.838 0-1.1426.3047-.33.838-.33 1.1426 0l2.666 2.666 5.9414-5.916c.3047-.33.8379-.33 1.1426 0"/>
    </svg>
  `;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
